import { useLocation } from 'react-router-dom';

import { useQueryControl } from '@bonusly/url';

/**
 * Hook to determine if a specific bonus media should be prioritized for autoplay
 * based on URL parameters and focused state.
 *
 * @param bonusId The ID of the bonus to check
 * @param focused Whether the bonus is currently in focus (e.g., in modal view)
 * @returns Whether this bonus should be prioritized for autoplay
 */
export const usePriorityMedia = (bonusId: string | undefined, focused: boolean): boolean => {
	// Always call hooks at the top level, regardless of conditions
	const location = useLocation();
	const { query: commentId } = useQueryControl('comment_id');

	// Only proceed with the logic if the bonus is focused
	if (!focused || !bonusId) return false;

	// Check if this video should be prioritized based on URL
	const isInBonusModal = location.pathname.includes('/bonuses/');
	const pathBonusId = location.pathname.match(/\/bonuses\/([a-z0-9]+)/)?.[1];
	const priorityBonusId = commentId || pathBonusId;

	return isInBonusModal && priorityBonusId === bonusId;
};
